export default __webpack_public_path__ + "static/media/speedometer.f671bef8.png";